import React, { Component, Fragment } from 'react';
import LandingHeader from '../components/landing/LandingHeader';
import LandingFooter from '../components/landing/LandingFooter';
import GetStarted from '../components/landing/GetStarted';
import Heading from '../components/global/Heading';
import ContentSection from '../components/landing/ContentSection';
import { Row, Col } from 'react-materialize';
import { Link } from 'react-router-dom';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';

import '../static/SecondaryPages.css';

const localeMessages = defineMessages({
	privacy_title: {
		id: 'privacy.title',
		defaultMessage: `Privacy Policy`,
	},
});

const Title = props => (
	<Fragment>
		<h1 className='mb-10 mt-20'>{props.children}</h1>
	</Fragment>
);

const Par = props => (
	<p className='mb-10'>{props.children}</p>
);

class Privacy extends Component {
	componentDidMount() {
		window.$('body').animate({ scrollTop: 0 }, 0);
	}
	
	render() {
		return (
			<Fragment>
				<LandingHeader history={this.props.history} disableAutoRoute={true}/>
				<Heading title={this.props.intl.formatMessage(localeMessages.privacy_title)} />

				<ContentSection noAnimate={true} addedSectionClass="pilotly-tos p-0 t-a-c-padding">
					<div className='tos-content-container'>

						<Par>
							<FormattedMessage
								id="privacy_policy.who_we_are_link"
								defaultMessage={`We are Pilotly Inc (“We” “Our” “Us” or “Pilotly”). You can learn more about our company by clicking on the following link: {who_we_are_link}`}
								values={{ who_we_are_link: <a href='https://www.pilot.ly/our-story'>https://www.pilot.ly/our-story</a> }}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.pilotly_market_research"
								defaultMessage={`Pilotly is an online data collection group focused on providing high-quality market research data to its clients who are in various business sectors, including other market research agencies and other global and corporate clients of all sizes. We also build and maintain large online consumer panels, providing real-time digital consumer insights to our clients via our market research surveys and analytics platforms.`}
							/>
						</Par>

						<ul className="pilotly-tos-list">
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.toc_purpose"
									defaultMessage={`What is the purpose of this privacy policy and what is our privacy commitment to you?`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.toc_data_collected"
									defaultMessage={`What personal data do we collect about you?`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.toc_how_collect"
									defaultMessage={`How do we collect your personal data?`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.toc_how_use_data"
									defaultMessage={`How do we use your personal data?`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.toc_cookies"
									defaultMessage={`What cookies do we use on our sites?`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.toc_international_transfers"
									defaultMessage={`International Transfers.`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.toc_data_security"
									defaultMessage={`What security measures do we undertake to protect your personal data?`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.toc_data_retention"
									defaultMessage={`What are our data retention and destruction policies?`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.toc_eea_legal_rights"
									defaultMessage={`Your legal rights if you are in the EEA`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.toc_process_data"
									defaultMessage={`What are the legal bases we rely on when processing your personal data?`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.toc_data_controller"
									defaultMessage={`Who is the data controller?`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.toc_policy_changes"
									defaultMessage={`Changes to the privacy policy.`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.toc_contact"
									defaultMessage={`Privacy contact details`}
								/>
							</li>
						</ul>

						<Title>
							<FormattedMessage
								id="privacy_policy.purpose_title"
								defaultMessage={`What is the purpose of this privacy policy and what is our Privacy Commitment to you?`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="privacy_policy.purpose"
								defaultMessage={`We respect your privacy and are committed to protecting your personal data. This privacy policy aims to give you information on how we collect and process your personal data through your use of our site {pilotly_link} (“site”) including any data you may provide through this sites when you sign up to our newsletters, purchase a product or service, take part in a survey, or take part in a competition (our “sites”).  It also explains your privacy rights and how laws that are applicable to you may protect you.`}
								values={{ pilotly_link: <a href='https://www.pilot.ly'>https://www.pilot.ly</a> }}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.no_children"
								defaultMessage={`These sites are not intended for children and we do not knowingly collect data relating to children.  Our sites are for use by consumers above the age of 13 years old.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.must_read"
								defaultMessage={`It is important that you read this privacy policy together with any other privacy policy or fair processing notice we may provide on specific occasions when we are collecting or processing personal data about you so that you are fully aware of how and why we are using your data. This privacy notice supplements the other notices and/or policies and is not intended to override them.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="privacy_policy.personal_data_collect_list_title"
								defaultMessage={`What personal data do we collect about you?`}
							/>
						</Title>

						<ul>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.personal_data_given"
									defaultMessage={`Information you give us. This is information about you that you give us by filling in forms on our sites or by corresponding with us by phone, e-mail or otherwise. It includes information you provide when you register to use our sites, subscribe to our mailing lists, including participating in discussion boards or other social media functions on our sites and when you report a problem with our sites. The information you give us may include your Identity data and your Contact data.`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.personal_data_collected"
									defaultMessage={`Information we collect about you. With regard to each of your visits to our sites we will automatically collect the following information:`}
								/>
							</li>
							<ul className="pilotly-tos-list">
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.personal_data_technical"
										defaultMessage={`Technical data, including the Internet protocol (IP) address used to connect your computer to the Internet, your login information, browser type and version, time zone setting, browser plug-in types and versions, operating system and platform.`}
									/>
								</li>
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.personal_data_metadata"
										defaultMessage={`Information about your visit, including the full Uniform Resource Locators (URL), clickstream to, through and from our sites (including date and time), publications or news you viewed or searched for, page response times, download errors, length of visits to certain pages, page interaction information (such as scrolling, clicks, and mouse-overs) and methods used to browse away from the page.`}
									/>
								</li>
							</ul>
						</ul>

						<Par>
							<FormattedMessage
								id="privacy_policy.aggregated_data"
								defaultMessage={`We also collect, use and share Aggregated Data such as statistical or demographic data for any purpose. Aggregated Data may be derived from your personal data but is not considered personal data in law as this data does not directly or indirectly reveal your identity (your data is anonymized with respect to any data we share). For example, we may aggregate your Usage Data to calculate the percentage of users accessing a specific websites feature. However, if we combine or connect Aggregated Data with your personal data so that it can directly or indirectly identify you, we treat the combined data as personal data which will be used in accordance with this privacy policy (and will not share with third parties).`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_not_provided"
								defaultMessage={`If you fail to provide personal data:  Where we need to collect personal data by law, or under the terms of a contract we have with you and you fail to provide that data when requested, we may not be able to perform the contract we have or are trying to enter into with you (for example, to provide you with goods or services). In this case, we may have to cancel a product or service you have with us but we will notify you if this is the case at the time.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_definition"
								defaultMessage={`Personal data, means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (anonymous data).`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.data_collect_use_store"
								defaultMessage={`We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:`}
							/>
						</Par>

						<ul className="pilotly-tos-list">
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.data_collect_identity"
									defaultMessage={`Identity data - name (includes first, last, maiden and married names), date of birth, marital status, gender, panelist id and username.`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.data_collect_contact"
									defaultMessage={`Contact data - postal address, email address and telephone number.`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.data_collect_special"
									defaultMessage={`Special categories of personal data - ethnic/racial origin, health, genetics, political opinion, religion, sexual orientation and sex life and biometrics (used for ID purposes).`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.data_collect_profile"
									defaultMessage={`Profile data - includes your username and password, purchases or orders made by you, your interests, preferences, feedback and survey responses.`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.data_collect_financial"
									defaultMessage={`Financial data includes payment card details. All financial data is managed by a reputable third-party, Braintree.  Please view their privacy policy to learn how payment details are managed www.braintree.com.`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.data_collect_transaction"
									defaultMessage={`Transaction data includes details about payments to and from you and other details of products and services you have purchased from us.`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.data_collect_technical"
									defaultMessage={`Technical data includes internet protocol (IP) addresses, login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform and other technology on the devices you use to access this websites.`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.data_collect_usage"
									defaultMessage={`Usage data includes information about how you use our sites, products and services.`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.data_collect_marketing"
									defaultMessage={`Marketing and Communications data includes your preferences in receiving marketing from us and our third parties and your communication preferences.`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.data_collect_other_sources"
									defaultMessage={`Information we receive from other sources. This is information we receive about you if you use any of the other websites we operate or the other services we provide. We are working closely with third parties (including, for example, business partners, sub-contractors in technical, payment and delivery services, advertising networks, analytics providers and search information providers).`}
								/>
							</li>
						</ul>

						<Title>
							<FormattedMessage
								id="privacy_policy.how_collect_data_title"
								defaultMessage={`How do we collect your personal data?`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="privacy_policy.how_collect_data_list"
								defaultMessage={`We use different methods to collect data from and about you including through:`}
							/>
						</Par>

						<ul>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.how_collect_data_direct"
									defaultMessage={`Direct interactions. You may give us your Identity data, Contact data and Financial Data by filling in forms or by corresponding with us by post, phone, email or otherwise. This includes personal data you provide when you:`}
								/>
							</li>
							<ul className="pilotly-tos-list">
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.how_collect_data_direct_"
										defaultMessage={`apply for our products or services;`}
									/>
								</li>
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.how_collect_data_direct_entry"
										defaultMessage={`enter you contact data or Identity data`}
									/>
								</li>
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.how_collect_data_direct_create_account"
										defaultMessage={`create an account on our sites;`}
									/>
								</li>
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.how_collect_data_direct_subscribe"
										defaultMessage={`subscribe to our service or publications;`}
									/>
								</li>
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.how_collect_data_direct_marketing"
										defaultMessage={`request marketing to be sent to you;`}
									/>
								</li>
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.how_collect_data_direct_promotion"
										defaultMessage={`enter a competition, promotion or survey; or`}
									/>
								</li>
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.how_collect_data_direct_feedback"
										defaultMessage={`give us some feedback.`}
									/>
								</li>
							</ul>
						</ul>

						<ul className="pilotly-tos-list">
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.how_collect_data_automated"
									defaultMessage={`Automated technologies or interactions. As you interact with our sites, we may automatically collect Technical Data about your equipment, browsing actions and patterns. We collect this personal data by using cookies, and other similar technologies. We may also receive Technical Data about you if you visit other websites that deploy our cookies.  Please see our cookie policy http://pilot.ly/legal/cookie-policy/ for further details.`}
								/>
							</li>
						</ul>

						<ul>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.how_collect_data_third_party"
									defaultMessage={`Third parties or publicly available sources. We may receive personal data about you from various third parties and public sources as set out below:`}
								/>
							</li>

							<ul>
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.how_collect_data_third_party_technical"
										defaultMessage={`Technical Data from the following parties:`}
									/>
								</li>

								<ul className="pilotly-tos-list">
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="privacy_policy.how_collect_data_third_party_analytics"
											defaultMessage={`analytics providers such as Google based outside the EU;`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="privacy_policy.how_collect_data_third_party_advertising"
											defaultMessage={`advertising networks based inside or outside the EU (such as Linked-In); and`}
										/>
									</li>
									<li className="pilotly-tos-listitem">
										<FormattedMessage
											id="privacy_policy.how_collect_data_third_party_search"
											defaultMessage={`search information providers inside or outside the EU (Google or Yahoo listing our websites near the tops of the list).`}
										/>
									</li>
								</ul>

								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.how_collect_data_third_party_technical_providers"
										defaultMessage={`Contact data, Financial data and Transaction Data from providers of technical, payment and delivery outside the EU.`}
									/>
								</li>
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.how_collect_data_third_party_technical_aggegators"
										defaultMessage={`Identity data and Contact Data from data brokers or aggregators based inside or outside the EU (such as Zoom Info).`}
									/>
								</li>
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.how_collect_data_third_party_technical_public"
										defaultMessage={`Identity data and Contact Data from publicly availably sources such as Companies House and the Electoral Register based inside the EU.`}
									/>
								</li>
							</ul>
						</ul>

						<Title>
							<FormattedMessage
								id="privacy_policy.data_usage_title"
								defaultMessage={`How do we use your personal data?`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="privacy_policy.data_usage_list"
								defaultMessage={`We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:`}
							/>
						</Par>

						<ul className="pilotly-tos-list">
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.data_usage_legitimate_interests"
									defaultMessage={`Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.`}
								/>
							</li>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.data_usage_legal_compliance"
									defaultMessage={`Where we need to comply with a legal or regulatory obligation.`}
								/>
							</li>
						</ul>

						<Par>
							<FormattedMessage
								id="privacy_policy.data_usage_purposes"
								defaultMessage={`Purposes for which we will use your personal data: We have set out below, in a table format, a description of all the ways we plan to use your personal data, and which of the legal bases we rely on to do so. We have also identified what our legitimate interests are where appropriate.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.data_usage_legal_grounds"
								defaultMessage={`Note that we may process your personal data for more than one lawful ground depending on the specific purpose for which we are using your data. Please contact us by emailing {inquiry_email} if you need details about the specific legal ground we are relying on to process your personal data where more than one ground has been set out in the table below.`}
								values={{ inquiry_email: <a href='mailto:inquiry@pilot.ly'>inquiry@pilot.ly</a> }}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="privacy_policy.processing_activities_title"
								defaultMessage={`Processing activities table`}
							/>
						</Title>

						<Row className='privacy-table valign-wrapper'>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_register"
										defaultMessage={`To register you as a new customer`}
									/>
								</p>
							</Col>

							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_register_indentity"
										defaultMessage={`(a) Identity`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_register_contact"
										defaultMessage={`(b) Contact`}
									/>
								</p>
							</Col>

							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_register_contract"
										defaultMessage={`Performance of a contract with you`}
									/>
								</p>
							</Col>
						</Row>

						{/* ---------------------------------------------------------------- */}
						<Row className='privacy-table valign-wrapper'>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_order_deliver"
										defaultMessage={`To process and deliver your order including:`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_order_charges"
										defaultMessage={`(a) Manage payments, fees and charges`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_order_collect_money"
										defaultMessage={`(b) Collect and recover money owed to us`}
									/>
								</p>
							</Col>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_order_identity"
										defaultMessage={`(a) Identity`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_order_contact"
										defaultMessage={`(b) Contact`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_order_financial"
										defaultMessage={`(c) Financial`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_order_transaction"
										defaultMessage={`(d) Transaction`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_order_marketing"
										defaultMessage={`(e) Marketing and Communications`}
									/>
								</p>
							</Col>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_order_contract"
										defaultMessage={`(a) Performance of a contract with you`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_order_debts"
										defaultMessage={`(b) Necessary for our legitimate interests (to recover debts due to us)`}
									/>
								</p>
							</Col>
						</Row>
						{/* ---------------------------------------------------------------- */}
						<Row className='privacy-table valign-wrapper'>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_relationship"
										defaultMessage={`To manage our relationship with you which will include:`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_relationship_changes"
										defaultMessage={`(a) Notifying you about changes to our terms or privacy policy`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_relationship_review"
										defaultMessage={`(b) Asking you to leave a review or take a survey`}
									/>
								</p>
							</Col>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_relationship_identity"
										defaultMessage={`(a) Identity`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_relationship_contact"
										defaultMessage={`(b) Contact`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_relationship_profile"
										defaultMessage={`(c) Profile`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_relationship_marketing"
										defaultMessage={`(d) Marketing and Communications`}
									/>
								</p>
							</Col>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_relationship_contract"
										defaultMessage={`(a) Performance of a contract with you`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_relationship_legal"
										defaultMessage={`(b) Necessary to comply with a legal obligation`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_relationship_interests"
										defaultMessage={`(c) Necessary for our legitimate interests (to keep our records updated and to study how customers use our products/services)`}
									/>
								</p>
							</Col>
						</Row>

						{/* ---------------------------------------------------------------- */}

						<Row className='privacy-table valign-wrapper'>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_survey"
										defaultMessage={`To enable you to partake in a prize draw, competition or complete a survey`}
									/>
								</p>
							</Col>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_survey_identity"
										defaultMessage={`(a) Identity`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_survey_contact"
										defaultMessage={`(b) Contact`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_survey_profile"
										defaultMessage={`(c) Profile`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_survey_usage"
										defaultMessage={`(d) Usage`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_survey_communications"
										defaultMessage={`(e) Marketing and Communications`}
									/>
								</p>
							</Col>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_survey_contract"
										defaultMessage={`(a) Performance of a contract with you`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_survey_interests"
										defaultMessage={`(b) Necessary for our legitimate interests (to study how customers use our products/services, to develop them and grow our business)`}
									/>
								</p>
							</Col>
						</Row>
						{/* ---------------------------------------------------------------- */}

						<Row className='privacy-table valign-wrapper'>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_protect"
										defaultMessage={`To administer and protect our business and this websites (including troubleshooting, data analysis, testing, system maintenance, support, reporting and hosting of data)`}
									/>
								</p>
							</Col>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_protect_identity"
										defaultMessage={`(a) Identity`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_protect_contact"
										defaultMessage={`(b) Contact`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_protect_technical"
										defaultMessage={`(c) Technical`}
									/>
								</p>
							</Col>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_protect_interests"
										defaultMessage={`(a) Necessary for our legitimate interests (for running our business, provision of administration and IT services, network security, to prevent fraud and in the context of a business reorganization or group restructuring exercise)`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_protect_legal"
										defaultMessage={`(b) Necessary to comply with a legal obligation`}
									/>
								</p>
							</Col>
						</Row>

						{/* ---------------------------------------------------------------- */}

						<Row className='privacy-table valign-wrapper'>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_content"
										defaultMessage={`To deliver relevant websites content to you and measure or understand the effectiveness of the content we serve to you`}
									/>
								</p>
							</Col>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_content_identity"
										defaultMessage={`(a) Identity`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_content_contact"
										defaultMessage={`(b) Contact`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_content_profile"
										defaultMessage={`(c) Profile`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_content_usage"
										defaultMessage={`(d) Usage`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_content_marketing"
										defaultMessage={`(e) Marketing and Communications`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_content_technical"
										defaultMessage={`(f) Technical`}
									/>
								</p>
							</Col>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_content_interests"
										defaultMessage={`Necessary for our legitimate interests (to study how customers use our products/services, to develop them, to grow our business and to inform our marketing strategy)`}
									/>
								</p>
							</Col>
						</Row>
						{/* ---------------------------------------------------------------- */}

						<Row className='privacy-table valign-wrapper'>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_analytics"
										defaultMessage={`To use data analytics to improve our sites, products/services, marketing, customer relationships and experiences`}
									/>
								</p>
							</Col>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_analytics_technical"
										defaultMessage={`(a) Technical`}
									/>
								</p>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_analytics_usage"
										defaultMessage={`(b) Usage`}
									/>
								</p>
							</Col>
							<Col s={4} className='privacy-table-cell'>
								<p>
									<FormattedMessage
										id="privacy_policy.processing_activities_analytics_interests"
										defaultMessage={`Necessary for our legitimate interests (to study how customers use our products/services, to develop them, to grow our business and to inform our marketing strategy)`}
									/>
								</p>
							</Col>
						</Row>

						<Par>
							<FormattedMessage
								id="privacy_policy.promotional_offers"
								defaultMessage={`Promotional offers from us: We may use your Identity data, Contact data, Technical data, Usage data and Profile data to form a view on what we think you may want or need, or what may be of interest to you. This is how we decide which products, services and offers may be relevant for you (we call this marketing).`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.marketing_communications"
								defaultMessage={`You will receive marketing communications from us if you have requested information from us or purchased services from us or if you provided us with your details when you entered a competition or registered for a promotion and, in each case, you have not opted out of receiving that marketing.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.opt_out"
								defaultMessage={`Opting out: You can ask us to stop sending you marketing messages at any time by following the opt-out links on any marketing message sent to you or by emailing us at {inquiry_email} at any time.  Where you opt out of receiving these marketing messages, this will not apply to personal data provided to us as a result of a product/service purchase, product/service experience or other transactions.`}
								values={{ inquiry_email: <a href='mailto:inquiry@pilot.ly'>inquiry@pilot.ly</a> }}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.change_of_purpose"
								defaultMessage={`Change of purpose: We will only use your personal data for the purposes for which we collected it, unless we reasonably consider that we need to use it for another reason and that reason is compatible with the original purpose. If you wish to get an explanation as to how the processing for the new purpose is compatible with the original purpose, please contact us by emailing {inquiry_email}.`}
								values={{ inquiry_email: <a href='mailto:inquiry@pilot.ly'>inquiry@pilot.ly</a> }}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.unrelated_purpose"
								defaultMessage={`If we need to use your personal data for an unrelated purpose, we will notify you and we will explain the legal basis which allows us to do so.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.process_without_consent"
								defaultMessage={`Please note that we may process your personal data without your knowledge or consent, in compliance with the above rules, where this is required or permitted by law.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.disclosure_of_data"
								defaultMessage={`Disclosures of your personal data: We may have to share your personal data with the parties set out below for the purposes set out in the processing activities table above.`}
							/>
						</Par>

						<ul>
							<li className="pilotly-tos-listitem">
								<FormattedMessage
									id="privacy_policy.third_parties"
									defaultMessage={`External third parties based in countries throughout the world, including countries that are not recognised as providing equivalent protection such as;`}
								/>
							</li>

							<ul className="pilotly-tos-list">
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.third_parties_service_providers"
										defaultMessage={`Service providers acting as processors and who provide us with IT and system administration services.`}
									/>
								</li>
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.third_parties_advisers"
										defaultMessage={`Professional advisers acting as processors or joint controllers including lawyers, bankers, auditors and insurers who provide consultancy, banking, legal, insurance and accounting services.`}
									/>
								</li>
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.third_parties_tax_authorities"
										defaultMessage={`Tax authorities, regulators and other authorities acting as processors or joint controllers who require reporting of processing activities in certain circumstances.`}
									/>
								</li>
								<li className="pilotly-tos-listitem">
									<FormattedMessage
										id="privacy_policy.third_parties_sell_transfer_merge"
										defaultMessage={`Third parties to whom we may choose to sell, transfer, or merge parts of our business or our assets. Alternatively, we may seek to acquire other businesses or merge with them. If a change happens to our business, then the new owners may use your personal data in the same way as set out in this privacy policy.`}
									/>
								</li>
							</ul>
						</ul>

						<Par>
							<FormattedMessage
								id="privacy_policy.third_parties_requirements"
								defaultMessage={`We require all third parties to respect the security of your personal data and to treat it in accordance with the law. We do not allow our third-party service providers to use your personal data for their own purposes and only permit them to process your personal data for specified purposes and in accordance with our instructions.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="privacy_policy.cookies_title"
								defaultMessage={`What Cookies do we use on our sites?`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="privacy_policy.site_cookies"
								defaultMessage={`We use site cookies to distinguish you from other users of our sites.  This helps us to understand the profile of our visitors, estimate visits to our sites and click throughs for specific campaigns. Cookies also help us to provide you with a good experience when you browse our sites and they also help to improve our sites.  For example, when you arrive at our site and you've already logged in within the past 30 days, we can automatically authenticate you when you visit us from the same device and web browser.`}
							/>
						</Par>

						<Par>							
							<FormattedMessage
								id="privacy_policy.cookie_definition"
								defaultMessage={`A cookie is a small file of letters and numbers that we store on your browser or the hard drive of your computer if you agree. Cookies contain information that is transferred to your computer's hard drive.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.cookie_policy"
								defaultMessage={`For more information about the cookies we use, please see {cookie_policy}`}
								values={{ cookie_policy: <Link to='/cookie-policy'>http://pilot.ly/cookie-policy/</Link> }}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.data_protection"
								defaultMessage={`Pilotly Inc., Privacy Shield Framework: Our global back up and hosting service center is located in the USA.  Pilotly recognizes that the EEA (including Switzerland) have established strict protections regarding the handling of personal data from the EEA, including requirements to provide adequate protection for such personal data transferred outside of the EEA. Pilotly ensures that it provides adequate protection for certain EEA personal data about individuals (including about you and our corporate clients, suppliers, business partners, job applicants and employees. Pilotly has therefore elected to self-certify to the EU-US Privacy Shield Framework and the Swiss-US Privacy Shield Framework administered by the US Department of Commerce ("Privacy Shield"). Pilotly is responsible for the processing of personal data it receives, under the Privacy Shield and subsequently transfers to a third party acting as an agent on its behalf for the purposes of providing back up services to ensure the security of your personal data. Pilotly adheres to the Privacy Shield Principles of Notice, Choice, Accountability for Onward Transfer, Security, Data Integrity and Purpose Limitation, Access, and Recourse, Enforcement, and Liability. If there is any conflict between the terms of this privacy policy and the Privacy Shield Principles, the Privacy Shield Principles shall govern.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.privacy_shield"
								defaultMessage={`For purposes of enforcing compliance with the Privacy Shield, Pilotly is subject to the investigatory and enforcement authority of the US Federal Trade Commission. For more information about the Privacy Shield, see the US Department of Commerce's Privacy Shield website located at {privacy_shield}. To review Pilotly's representation on the Privacy Shield list, see the US Department of Commerce's Privacy Shield self-certification list located at {privacy_shield_list}.`}
								values={{ privacy_shield: <a href='https://www.privacyshield.gov'> https://www.privacyshield.gov</a>, privacy_shield_list: <a href='https://www.privacyshield.gov/list'>https://www.privacyshield.gov/list</a> }}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="privacy_policy.security_measures_title"
								defaultMessage={`What security measures do we undertake to protect your personal data?`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="privacy_policy.security_measures"
								defaultMessage={`We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know. They will only process your personal data on our instructions and they are subject to a duty of confidentiality.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.data_breach"
								defaultMessage={`We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="privacy_policy.data_destruction_title"
								defaultMessage={`What are our data retention and destruction policies?`}
							/>
						</Title>
						
						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_retention"
								defaultMessage={`We will only retain your personal data for as long as necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_retention_period"
								defaultMessage={`To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorized use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal requirements.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_delete"
								defaultMessage={`If you are a citizen or resident of the EEA, or we are processing your personal data in the EEA, in some circumstances you can ask us to delete your data: see the section entitled Your legal rights if you are in the EEA below for further information.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="privacy_policy.eea_rights_title"
								defaultMessage={`Your legal rights if you are in the EEA`}
							/>
						</Title>
						
						<Par>
							<FormattedMessage
								id="privacy_policy.eea_rights_list"
								defaultMessage={`If you are a EEA citizen or resident, you have the right to:`}
							/>
						</Par>

						<Par>
							
							<FormattedMessage
								id="privacy_policy.personal_data_access"
								defaultMessage={`Request access to your personal data (commonly known as a "data subject access request"). This enables you to receive a copy of the personal data we hold about you and to check that we are lawfully processing it.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_request_correction"
								defaultMessage={`Request correction of the personal data that we hold about you. This enables you to have any incomplete or inaccurate data we hold about you corrected, though we may need to verify the accuracy of the new data you provide to us.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_request_erasure"
								defaultMessage={`Request erasure of your personal data. This enables you to ask us to delete or remove personal data where there is no good reason for us continuing to process it. You also have the right to ask us to delete or remove your personal data where you have successfully exercised your right to object to processing (see below), where we may have processed your information unlawfully or where we are required to erase your personal data to comply with local law. Note, however, that we may not always be able to comply with your request of erasure for specific legal reasons which will be notified to you, if applicable, at the time of your request.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_objection"
								defaultMessage={`Object to processing of your personal data where we are relying on a legitimate interest (or those of a third party) and there is something about your particular situation which makes you want to object to processing on this ground as you feel it impacts on your fundamental rights and freedoms. You also have the right to object where we are processing your personal data for direct marketing purposes. In some cases, we may demonstrate that we have compelling legitimate grounds to process your information which override your rights and freedoms.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_restrict_processing"
								defaultMessage={`Request restriction of processing of your personal data. This enables you to ask us to suspend the processing of your personal data in the following scenarios: (a) if you want us to establish the data's accuracy; (b) where our use of the data is unlawful but you do not want us to erase it; (c) where you need us to hold the data even if we no longer require it as you need it to establish, exercise or defend legal claims; or (d) you have objected to our use of your data but we need to verify whether we have overriding legitimate grounds to use it.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_request_transfer"
								defaultMessage={`Request the transfer of your personal data to you or to a third party. We will provide to you, or a third party you have chosen, your personal data in a structured, commonly used, machine-readable format. Note that this right only applies to automated information which you initially provided consent for us to use or where we used the information to perform a contract with you.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_withdraw_consent"
								defaultMessage={`Withdraw consent at any time where we are relying on consent to process your personal data. However, this will not affect the lawfulness of any processing carried out before you withdraw your consent. If you withdraw your consent, we may not be able to provide certain products or services to you. We will advise you if this is the case at the time you withdraw your consent.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_contact_us"
								defaultMessage={`If you wish to exercise any of the rights set out above, please contact us by emailing to the appropriate email address in the Privacy Contact below.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="privacy_policy.no_fee_title"
								defaultMessage={`No fee usually required`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="privacy_policy.no_fee_access"
								defaultMessage={`You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive. Alternatively, we may refuse to comply with your request in these circumstances.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="privacy_policy.what_we_need_title"
								defaultMessage={`What we may need from you`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="privacy_policy.what_we_need_information"
								defaultMessage={`We may need to request specific information from you to help us confirm your identity and ensure your right to access your personal data (or to exercise any of your other rights). This is a security measure to ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further information in relation to your request to speed up our response.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.reuquest_response_time"
								defaultMessage={`We try to respond to all legitimate requests within one month. Occasionally it may take us longer than a month if your request is particularly complex or you have made a number of requests. In this case, we will notify you and keep you updated.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="privacy_policy.personal_data_legal_title"
								defaultMessage={`What are the legal bases we rely on when using your personal data?`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_legal_collect_list"
								defaultMessage={`The law on data protection in the EEA sets out a number of different reasons for which a company that is processing personal data may collect and process such personal data, including:`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_legal_consent"
								defaultMessage={`Consent - Generally we do not rely on consent as a legal basis for processing your personal data other than in relation to sending third party direct marketing communications to you via email or text message. You have the right to withdraw consent to marketing at any time by emailing to the appropriate email address in the Privacy Contact below`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_legal_legitimate_interest"
								defaultMessage={`Legitimate Interest means the interest of our business in conducting and managing our business to enable us to give you the best service/product and the best and most secure experience. We make sure we consider and balance any potential impact on you (both positive and negative) and your rights before we process your personal data for our legitimate interests. We do not use your personal data for activities where our interests are overridden by the impact on you (unless we have your consent or are otherwise required or permitted to by law). You can obtain further information about how we assess our legitimate interests against any potential impact on you in respect of specific activities by emailing to the appropriate email address in the Privacy Contact below.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_legal_performance_of_contract"
								defaultMessage={`Performance of Contract means processing your data where it is necessary for the performance of a contract to which you are a party or to take steps at your request before entering into such a contract.`}
							/>
						</Par>

						<Par>
							<FormattedMessage
								id="privacy_policy.personal_data_legal_compliance"
								defaultMessage={`Comply with a legal or regulatory obligation means processing your personal data where it is necessary for compliance with a legal or regulatory obligation that we are subject to.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="privacy_policy.changes_title"
								defaultMessage={`Changes to our privacy policy`}
							/>
						</Title>

						<Par>
							<FormattedMessage
								id="privacy_policy.changes_notification"
								defaultMessage={`Any changes we make to our privacy policy in the future will be posted on this page, do please check back frequently to see any updates or changes to our privacy policy.`}
							/>
						</Par>

						<Title>
							<FormattedMessage
								id="privacy_policy.contact_title"
								defaultMessage={`Privacy contact`}
							/>
						</Title>

						<Title>
							<FormattedMessage
								id="privacy_policy.for_non_eea_title"
								defaultMessage={`FOR NON-EEA CITIZENS/RESIDENTS`}
							/>
						</Title>

						<ul>
							<li>Pilotly Corporate Webmaster</li>
							<li>Suite 2000</li>
							<li>21 River Road</li>
							<li>Wilton CT 06897</li>
							<li>USA</li>
							<li>E-Mail: <a href='mailto:privacy@Pilotly.com'>Pilotly@Pilotly.com</a></li>
						</ul>

						<Title>
							<FormattedMessage
								id="privacy_policy.for_eaa_title"
								defaultMessage={`FOR EEA CITIZENS/RESIDENTS`}
							/>
						</Title>

						<ul>
							<li>The Data Protection Officer </li>
							<li>Pilotly SAS</li>
							<li>5, avenue du Château </li>
							<li>94300 Vincennes France </li>
							<li>E-Mail: <a href='mailto:privacy@Pilotly.com'>privacy@Pilotly.com</a></li>
						</ul>
					</div>
				</ContentSection>

				<GetStarted />
				<LandingFooter />
			</Fragment>
		);
	}
}

export default injectIntl(Privacy);



// WEBPACK FOOTER //
// ./src/pages/Privacy.js